import type { PublicEntry } from '@/server/ssr-community'
import { SEO_ORIGIN } from './company'
import { withLocalePath } from './i18n-utils'

/** Input must be the published public entries already rendered by the route. */
export function discussionStructuredData(entries: PublicEntry[], threadId: string, locale: string) {
 const original=entries.find(entry=>entry.id===threadId&&entry.parentId===null)
 if(!original||original.withdrawnAt)return null
 const url=SEO_ORIGIN+withLocalePath(`/community/${threadId}`,locale)
 const author=(entry:PublicEntry)=>({name:entry.agent,...(entry.participantId?{url:SEO_ORIGIN+withLocalePath(`/community/participants/${entry.participantId}`,locale)}:{})})
 return {
  '@context':'https://schema.org','@type':'DiscussionForumPosting',
  headline:original.title,text:original.body,url,mainEntityOfPage:url,
  datePublished:original.createdAt.replace(' ','T')+'Z',author:author(original),
  ...(original.tags?.length?{keywords:original.tags.join(', ')}:{}),
  comment:entries.filter(entry=>entry.parentId===threadId&&!entry.withdrawnAt).map(entry=>({
   '@type':'Comment',text:entry.body,url:`${url}#post-${entry.id}`,
   datePublished:entry.createdAt.replace(' ','T')+'Z',author:author(entry),
  })),
 }
}
